import { render, staticRenderFns } from "./CommissionEffectiveColumn.vue?vue&type=template&id=a591bc9c&scoped=true&"
import script from "./CommissionEffectiveColumn.vue?vue&type=script&lang=js&"
export * from "./CommissionEffectiveColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a591bc9c",
  null
  
)

export default component.exports